import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComponentBase } from '~/infrastructure/component-base';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { LocationsService } from '~/services/modules/stocks/locations';
import { DateTimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { FormatService } from '~/services/administration.ts/format';
import { TransactionDateEditingService } from '~/services/modules/stocks/administration/transaction-date-editing';
import { CycleCountService } from '~/services/modules/assets/transactions/CycleCount';
import { CycleCountSummary } from '~/models/modules/Asset/Transactions/CycleCount/CycleCount';
import { PageState } from '~/shared/enums/stock-files.enum';
import { UsersService } from '~/services/administration.ts/users';
import { Router } from '@angular/router';
import { GridComponent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'app-cycle-count',
    templateUrl: './cycle-count.html',
    styleUrl: './cycle-count.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CycleCountComponent extends ComponentBase
  implements OnInit {
  @ViewChild('kendo_Start_Date_Time_Piker')
  kendoStartDateTimePiker: DateTimePickerComponent;
  @ViewChild('kendo_combo_accounts') kendoComboAccounts: ComboBoxComponent;
  @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
  @ViewChild('grid') grid: GridComponent;

  _exportFileName: string = "cycle-count";
  _allSelected: boolean = false;
  _currentUser: UserSummary;
  _theme: string;
  _form: FormGroup;
  _invalidForm: boolean;
  _addClassActiveLocation: boolean = false;
  _addClassActiveGrid: boolean = false;
  _selectedLocations: any[] = [];
  _locations: any[] = [];
  _locationsFiltered: any[];
  _datePickerFormat: string;
  _costFormat: string;
  _dateEnabled: boolean;
  loggedInSiteId: any;
  radio1 = {
    layout: "Item",
  };
  value: number = 0.2;
  _pageState: PageState;
  public _cycleCountGridData: any[] = [];
  _addClassActive3: boolean;
  _totalPercentage: number = 0;
  _transactionId: number = 0;
  _percentageReportValue: number;
  _processPercentage: number;

  public areaList: Array<any> = [
    { text: "Small", value: 1 },
    { text: "Medium", value: 2 },
    { text: "Large", value: 3 },
  ];
  _persons: any[];
  _maxChunkPercentage = 1;
  _isDrafted: boolean;
  _pdfColumns: any[] = [
    { field: 'assetName', name: 'Inventory #', width: 300 }
    , { field: 'expectedLocationName', name: 'Expected Location', width: 300 }
    , { field: 'assetActualLocationName', name: 'Actual Location"', width: 300 }
    , { field: 'expectedPersonName', name: 'Expected Person', width: 300 }
    , { field: 'assetActualPersonName', name: 'Actual Person', width: 300 }
  ]

  constructor(
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutComponent: LayoutComponent,
    private _layoutManager: LayoutManagerService,
    private _securityService: SecurityService,
    private _locationsService: LocationsService,
    private _usersService: UsersService,
    private _formatService: FormatService,
    private _TransactionDateEditting: TransactionDateEditingService,
    private _cycleCountService: CycleCountService,
    private router: Router
  ) {
    super();
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._currentUser = this._securityService.currentUser;
  }

  //#region  ngOnInit
  ngOnInit() {
    this._initForm();
    //this._OpenAccount();
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
    this.loggedInSiteId = JSON.parse(loggedInAccountSites)[0].siteId;
    this._LoadLocation(this.loggedInSiteId);
    this._LoadPersons();
    // this._LoadLocations();
    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
    this.getDateEnabledOption();
    this._LoadDraftedTransaction();
  }

  _LoadDraftedTransaction() {
    this._cycleCountService.LoadDraftedTransaction().subscribe((res: any) => {
      if (res) {
        this._form.patchValue({
          countType: res.countType,
          percentage: res.assetCycleCountChunks[0].percentage / 100,
          cycleName: res.assetCycleCountChunks[0].name,
          transactionDate: new Date(res.transactionDate)
        });
        this._totalPercentage = res.percentage;
        this._maxChunkPercentage = 1 - (this._totalPercentage / 100);
        this._cycleCountGridData = res.assetCycleCountChunks[0].assetCycleCountChunkDetails;
        this._cycleCountGridData.forEach(c => {
          c.assetActualLocationName = this._locations?.find(l => l.id == c.assetActualLocationId)?.code;
          c.assetActualPersonName = this._persons?.find(p => p.id == c.assetActualPersonId)?.personDisplay;
        });
        this._transactionId = res.id;
        this._isDrafted = true;
        this._dateEnabled = false;
        this._form.get("transactionDate").disable();
        this._form.get("countType").disable();
        this._form.get("percentage").disable();
        this._form.get("cycleName").disable();
      }
      else {
        this._cycleCountService.LoadOpenedTransaction().subscribe((res1: any) => {
          if (res1) {
            this._form.patchValue({
              countType: res1.countType,
              transactionDate: new Date(res1.transactionDate)
            });
            this._totalPercentage = res1.percentage;
            this._maxChunkPercentage = 1 - (this._totalPercentage / 100);
            this._transactionId = res1.id;
            this._form.get("countType").disable();
          }
        });
      }
    });
  }
  //#endregion

  //#region  _OpenAccount
  _OpenAccount() {
    if (this._currentUser.isEnterprise) {
      setTimeout(() => {
        this.kendoComboAccounts.toggle(true);
        this.kendoComboAccounts.focus();
      });
    } else {
      setTimeout(() => {
        this.kendoStartDateTimePiker.focus();
        this.kendoStartDateTimePiker.toggle();
      }, 100);
    }
  }
  //#endregion

  _getDefaultLocation(id: number) {
  }

  //#region  _LoadLocation
  _LoadLocation(siteId: number) {

    let siteModel = {
      siteId: siteId
    }
    return this._locationsService
      //.getLocationListingBySite(siteId)
      .getLocationsByAccounts(siteModel)
      .subscribe((data: any) => {
        this._locations = data;
        this._locationsFiltered = data;
      });
  }
  //#endregion

  //#region  _LoadLocation
  _LoadPersons() {
    return this._usersService
      .getPersons()
      .subscribe((data: any[]) => {
        this._persons = data.map(p => ({
          ...p,
          personDisplay: p.code ? `${p.code} - ${p.firstName || ''} ${p.lastName || ''}`.trim() : `${p.firstName || ''} ${p.lastName || ''}`.trim()
        }));
      });
  }
  //#endregion

  //#region  _LoadLocations
  // _LoadLocations() {
  //    this._locationsService
  //     //.getLocationListingBySite(siteId)
  //     .getLocationListing()
  //     .subscribe((data: any) => {
  //       this._locations = data;
  //     });
  // }
  //#endregion

  //#region _onLocationChange
  _onLocationChange(e: any) {
    this._selectedLocations = e;
  }
  //#endregion

  //#region  _initForm
  private _initForm() {
    this._form = this._fb.group({
      transactionDate: [new Date(), Validators.required],
      percentage: [0, [Validators.required, Validators.min(0.01)]],
      percentageReport: 0,
      countType: [0, Validators.required],
      cycleName: ""
    });
  }
  //#endregion

  //#region  _onSave
  _onSave(e: any) {
    let data = this._cycleCountGridData.filter(c => c.adjust && c.quantityToPost > 0);
    if (data.length > 0) {
      this._cycleCountService.UpdateStockPhysInvList(data).subscribe((res) => {

        let dataBack = res.data as CycleCountSummary[];
        dataBack.forEach(element => {

          let index = this._cycleCountGridData.findIndex(c => c.id == element.id);
          this._cycleCountGridData.splice(index, 1);
        });
      });
    }
    else {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please add the items you want to Cycle Count.',
        withoutConfirm: true
      });
    }
  }
  //#endregion



  //#region  _onStateChanges
  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }
  //#endregion

  //#region  ngOnDestroy
  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }
  //#endregion

  //#region  _startDateSubmited
  _startDateSubmited() {
    setTimeout(() => {
      this.kendoStartDateTimePiker.blur();
    });
  }
  //#endregion


  //#region  Functions Select

  //#region  _selectAdjustAll
  _selectAdjustAll() {
    this._allSelected = !this._allSelected;
    this._cycleCountGridData.forEach((element) => {
      element.adjust = this._allSelected;
    });
    this._CheckSelectAll();
  }
  //#endregion

  //#region _checkAdjust
  _checkAdjust(data: any) {
    var index = this._cycleCountGridData.indexOf(data);
    this._cycleCountGridData[index].adjust =
      !this._cycleCountGridData[index].adjust;
    this._CheckSelectAll();
  }
  //#endregion

  //#region  CheckSelectAll
  _CheckSelectAll() {
    this._allSelected =
      this._cycleCountGridData.length ==
      this._cycleCountGridData.filter((x) => x.adjust).length;
  }
  //#endregion
  //#endregion

  //#region  _gridclicked
  _gridclicked() {
    // this._addClassActiveLocation = false;
    // this.kendoStartDateTimePiker.toggle(false);
    // this.kendoStartDateTimePiker.blur();
    // this.kendoEndDateTimePiker.toggle(false);
    // this.kendoEndDateTimePiker.blur();
    // this._addClassActiveGrid = true;
  }
  //#endregion

  //#region  _listboxClicked
  _listboxClicked() {
    this._addClassActiveLocation = true;
    if (this.kendoStartDateTimePiker) {
      this.kendoStartDateTimePiker.toggle(false);
      this.kendoStartDateTimePiker.blur();
    }
    this._addClassActiveGrid = false;
    this._addClassActive3 = false;
  }
  //#endregion
  _step3Clicked() {
    this._addClassActive3 = true;
    if (this.kendoStartDateTimePiker) {
      this.kendoStartDateTimePiker.toggle(false);
      this.kendoStartDateTimePiker.blur();
    }
    this._addClassActiveGrid = false;
    this._addClassActiveLocation = false;
  }

  //#region  _startDateOpened
  _startDateOpened() {
    this._addClassActiveLocation = false;
    this._addClassActiveGrid = false;
  }

  //#endregion

  //#region  _endDateOpened
  _endDateOpened() {
    this._addClassActiveLocation = false;
    this._addClassActiveGrid = false;
  }
  //#endregion


  //#region  getDateEnabledOption
  getDateEnabledOption() {
    this._TransactionDateEditting
      .getTransactionDateEditing('get-data')

      .subscribe((x: any) => {
        if (x)
          this._dateEnabled = x.transactionDateEditing;
      });
  }
  //#endregion

  //#region  _onAllVariance
  _onAllVariance() {
    this._allSelected = false;
    if (this._form.valid && this._selectedLocations.length > 0) {
      this._cycleCountGridData = [];
      var locIdList = this._selectedLocations.map((c) => c.id);
      this._cycleCountService
        .GetStockPhysInvByDateAndLoc(locIdList, this._form.value)

        .subscribe((res: any) => {
          this._cycleCountGridData =
            res.data as CycleCountSummary[];
        });
    }

  }
  //#endregion

  //#region  QuantityToPost
  _QuantityToPost(data: any, event: any) {
    var index = this._cycleCountGridData.indexOf(data);
    this._cycleCountGridData[index].quantityToPost = event;
  }
  //#endregion

  _startCycleCount() {
    this._form.get('cycleName')?.clearValidators();
    this._form.get('cycleName')?.updateValueAndValidity();

    if (this._form.invalid) {
      this._invalidForm = true;
      return;
    }
    this._form.controls['percentage'].setValue(Math.round(this._form.get('percentage')?.value * 10) / 10);
    this._cycleCountService.LoadDataRandomly(this._form.get('percentage')?.value * 100, this._transactionId, this._form.get("countType")?.value).subscribe(
      (data: CycleCountSummary[]) => {
        this._cycleCountGridData = data;
        this._processPercentage = this._form.get('percentage')?.value * 100;
        this._cycleCountGridData.forEach(c => {
          c.assetActualLocationName = this._locations?.find(l => l.id == c.assetActualLocationId)?.code;
          c.assetActualPersonName = this._persons?.find(p => p.id == c.assetActualPersonId)?.personDisplay;
        });
      }
    );
  }

  _reset() {
    const currentUrl = this.router.url;

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  _print() {
    this._export();
  }

  _email() {

  }

  _export() {
    const PdfData = { data: this._cycleCountGridData, total: this._cycleCountGridData.length }

    this.grid.data = this._cycleCountGridData;

    this.grid.saveAsPDF();
    this.grid.data = PdfData;
  }

  _process() {
    if (!this._form.get('cycleName').hasValidator(Validators.required)) {
      this._form.get('cycleName')?.setValidators([Validators.required]);
      this._form.get('cycleName')?.updateValueAndValidity();
    }

    if (this._form.invalid) {
      this._invalidForm = true;
      return;
    }

    if (!this._isDrafted) {
      const model = {
        name: this._form.get('cycleName')?.value,
        percentage: this._processPercentage,
        assetCycleCountChunkDetails: this._cycleCountGridData,
        cycleCountTransactionId: this._transactionId,
        assetCycleCount: { countType: this._form.get('countType')?.value, transactionDate: this._form.get('transactionDate')?.value }
      };
      this._cycleCountService.Process(model).subscribe(
        (data: CycleCountSummary[]) => { this._reset(); }
      );
    } else {
      const model = {
        assetCycleCountChunkDetails: this._cycleCountGridData,
        transactionId: this._transactionId
      };
      this._cycleCountService.UpdateDetails(model).subscribe(
        (data: CycleCountSummary[]) => { this._reset(); }
      );
    }
  }

  _save() {
    if (!this._form.get('cycleName').hasValidator(Validators.required)) {
      this._form.get('cycleName')?.setValidators([Validators.required]);
      this._form.get('cycleName')?.updateValueAndValidity();
    }

    if (this._form.invalid) {
      this._invalidForm = true;
      return;
    }

    if (!this._isDrafted) {
      const model = {
        name: this._form.get('cycleName')?.value,
        percentage: this._processPercentage,
        assetCycleCountChunkDetails: this._cycleCountGridData,
        cycleCountTransactionId: this._transactionId,
        isDraft: true,
        assetCycleCount: { countType: this._form.get('countType')?.value, transactionDate: this._form.get('transactionDate')?.value }
      };
      this._cycleCountService.Process(model).subscribe(
        (data: CycleCountSummary[]) => { this._reset(); }
      );
    } else {
      const model = {
        assetCycleCountChunkDetails: this._cycleCountGridData
      };
      this._cycleCountService.UpdateDetails(model).subscribe(
        (data: CycleCountSummary[]) => { this._reset(); }
      );
    }
  }

  _percentageReport() {
    this._form.controls['percentageReport'].setValue(Math.round(this._form.get('percentageReport')?.value * 10) / 10);
  }

  getSelectedPerson(item: any): number {
    return this._persons?.find(p => p.id == item.assetActualPersonId);
  }

  percentageReportChange(e: any) {
    setTimeout(() => {
      let p = this._form.get('percentageReport')?.value;
      p = p / 100;
      if (p > 1) p = 1;
      if (p < 0) p = 0;
      this._form.controls['percentageReport'].setValue(p);
    });
  }

  percentageChange(e: any) {
    setTimeout(() => {
      let p = this._form.get('percentage')?.value;
      p = p / 100;
      if (p > this._maxChunkPercentage) p = this._maxChunkPercentage;
      if (p < 0) p = 0;
      this._form.controls['percentage'].setValue(p);
    });
  }

  onPersonChange(person: any, item: any) {
    item.assetActualPersonId = person.id;
    item.assetActualPersonName = this._persons?.find(l => l.id == item.assetActualPersonId)?.personDisplay;
  }

  getSelectedLocation(item: any): number {
    return this._locations?.find(l => l.id == item.assetActualLocationId);
  }

  onLocationChange(location: any, item: any) {
    item.assetActualLocationId = location.id;
    item.assetActualLocationName = this._locations?.find(l => l.id == item.assetActualLocationId)?.code;
  }
}
